import React from 'react';
import { motion } from 'framer-motion';
const dataPoints = [{
  id: 1,
  country: 'Maroc',
  x: '20%',
  y: '20%'
}, {
  id: 2,
  country: 'Algérie',
  x: '25%',
  y: '25%'
}, {
  id: 3,
  country: 'Tunisie',
  x: '30%',
  y: '20%'
}, {
  id: 4,
  country: 'Égypte',
  x: '40%',
  y: '25%'
}, {
  id: 5,
  country: 'Sénégal',
  x: '15%',
  y: '35%'
}, {
  id: 6,
  country: "Côte d'Ivoire",
  x: '22%',
  y: '42%'
}, {
  id: 7,
  country: 'Ghana',
  x: '25%',
  y: '42%'
}, {
  id: 8,
  country: 'Nigeria',
  x: '30%',
  y: '40%'
}, {
  id: 9,
  country: 'Cameroun',
  x: '35%',
  y: '45%'
}, {
  id: 10,
  country: 'Kenya',
  x: '50%',
  y: '45%'
}, {
  id: 11,
  country: 'Éthiopie',
  x: '50%',
  y: '35%'
}, {
  id: 12,
  country: 'Afrique du Sud',
  x: '40%',
  y: '70%'
}, {
  id: 13,
  country: 'Angola',
  x: '35%',
  y: '60%'
}, {
  id: 14,
  country: 'RDC',
  x: '40%',
  y: '50%'
}];
export function AfricaMap() {
  return <div className="relative w-full h-full" data-id="element-926">
      <svg viewBox="0 0 100 100" className="w-full h-full" style={{
      filter: 'drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.1))'
    }} data-id="element-927">
        <defs data-id="element-928">
          <linearGradient id="africaGradient" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-929">
            <stop offset="0%" stopColor="#0a2463" stopOpacity="0.8" data-id="element-930" />
            <stop offset="100%" stopColor="#0a2463" stopOpacity="0.6" data-id="element-931" />
          </linearGradient>
        </defs>
        {/* Simplified Africa continent shape */}
        <path d="M30,15 C35,12 45,10 50,15 C55,12 65,15 70,20 C75,25 80,35 75,45 
             C80,55 75,65 70,75 C65,80 55,85 45,80 C35,85 25,80 20,70 
             C15,60 15,50 20,40 C15,30 25,20 30,15 Z" fill="url(#africaGradient)" stroke="#0a2463" strokeWidth="0.5" data-id="element-932" />
        {/* Data points */}
        {dataPoints.map(point => <g key={point.id} data-id="element-933">
            <motion.circle cx={point.x} cy={point.y} r="1.5" fill="#ffc857" initial={{
          opacity: 0.5,
          scale: 0.8
        }} animate={{
          opacity: [0.5, 1, 0.5],
          scale: [0.8, 1.2, 0.8]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          delay: point.id * 0.2
        }} data-id="element-934" />
            <motion.circle cx={point.x} cy={point.y} r="0.8" fill="#ffffff" data-id="element-935" />
          </g>)}
        {/* Connection lines */}
        {dataPoints.map((point, index) => {
        if (index % 3 === 0 && index < dataPoints.length - 1) {
          return <motion.line key={`line-${index}`} x1={point.x} y1={point.y} x2={dataPoints[index + 1].x} y2={dataPoints[index + 1].y} stroke="#ffc857" strokeWidth="0.3" strokeDasharray="1" initial={{
            pathLength: 0,
            opacity: 0
          }} animate={{
            pathLength: 1,
            opacity: 0.5
          }} transition={{
            duration: 2,
            delay: index * 0.1
          }} data-id="element-936" />;
        }
        return null;
      })}
      </svg>
      {/* Live data indicator */}
      <div className="absolute top-4 right-4 flex items-center" data-id="element-937">
        <div className="relative mr-2" data-id="element-938">
          <div className="h-2 w-2 bg-green-500 rounded-full" data-id="element-939"></div>
          <div className="absolute top-0 left-0 h-2 w-2 bg-green-500 rounded-full animate-ping" data-id="element-940"></div>
        </div>
        <span className="text-xs font-medium text-white" data-id="element-941">Live Data</span>
      </div>
    </div>;
}